<template>
  <app-layout>
     <template v-slot:headerTitle>
         Edit Voucher Template
    </template>
    <template v-slot:headerNav>
           <nav-items></nav-items>
     </template>
    <br>
    <!-- excel form starts -->
    <div>
       <div class="clearfix"></div>
        <br><br><br>
        <div class="container ">
        <div>
            <h5 class="pl-8 text-left mb-1 -mt-7">Edit Voucher Template</h5>
               <ul style="padding-left:10px;" class="pt-2 pb-2 ">
                    <li class="pr-2 " style="float:left;" v-for="(v,k) in breadcrumbs">
                        <jet-nav-link
                            :href="route(v.route,1)"
                            :active="route().current(v.route)"
                        >
                            {{v.name}}
                        </jet-nav-link>
                        >
                    </li>
                </ul>
        </div>
          <!-- <div class="row">
          </div> -->
           <div class="bg-white sm:mx-8 lg:mx-8 mt-9">
          <div class='row max-w-7xl mx-auto sm:px-6 lg:px-8 sm:mx-4 lg:mx-4 pt-3'>
                              <div class=" form-group mt-1 merg text-left" >
                                  <div class="opt grid grid-cols-3 gap-10 flex justify-start ">
                                  <div class="option col-span-1">
                                    <span> Company Name:</span>
                                      <DxSelectBox
                                      :data-source="company_names"
                                      :value="this.form_data.company_name"
                                      :accept-custom-value="true"
                                      @value-changed="fetchCompanyName($event)"
                                      />
                                      <span style="visibility:hidden;"> Obj View:</span>
                                      <DxTextBox
                                      v-model:value="persisted_view"
                                      :visible="false"
                                      />
                                      <span style="visibility:hidden;"> Vch Type:</span>
                                      <DxTextBox
                                      v-model:value="vch_type"
                                      :visible="false"
                                      />
                                  </div>
                                  <div class="option col-span-1">
                                      <span>Select File:</span>
                                      <div class="widget-container flex-box ledger_upload">
                                            <div
                                            id="dropzone-external"
                                            class="flex-box"
                                            :class="[isDropZoneActive
                                                ? 'dx-theme-accent-as-border-color dropzone-active'
                                                : 'dx-theme-border-color']"
                                            >
                                            <img
                                                id="dropzone-image"
                                                :src="imageSource"
                                                v-if="imageSource"
                                                alt=""
                                            >
                                            <div
                                                id="dropzone-text"
                                                class="flex-box"
                                                v-if="textVisible"
                                            >
                                                <span>Drag & Drop or Upload the  Excel file here</span>
                                            </div>
                                            <div
                                                id="dropzone-text"
                                                class="flex-box"
                                                v-if="uploaded_text_Visible"
                                            >
                                                <span >{{uploaded_text}}</span>
                                            </div>
                                            <DxProgressBar
                                                id="upload-progress"
                                                :min="0"
                                                :max="100"
                                                width="30%"
                                                :show-status="false"
                                                :visible="progressVisible"
                                                :value="progressValue"
                                            />
                                        </div>
                                        </div>
                                            <DxFileUploader
                                                id="ledger-file-uploader"
                                                dialog-trigger="#dropzone-external"
                                                drop-zone="#dropzone-external"
                                                accept="xlsx/*"
                                                :multiple="false"
                                                upload-mode="instantly"
                                                upload-url="https://js.devexpress.com/Demos/NetCore/FileUploader/Upload"
                                                :visible="false"
                                                @drop-zone-enter="onDropZoneEnter"
                                                @drop-zone-leave="onDropZoneLeave"
                                                @uploaded="onUploaded"
                                                @progress="onProgress"
                                                @upload-started="onUploadStarted"
                                                @value-changed="handleFileUpload($event)"
                                            />
                                  </div>
                                  <div class="option col-span-1 pt-2" id="sub"><button type="button" class="inventory-btn" v-on:click="processUpload($event)">SubmitExcel</button></div>
                                  </div>
                                   </div>
                              <!-- datagrid -->
                                <div class="panel panel-info">
                                      <!-- <div class="panel-heading">
                                      </div> -->
                                                
                                      <div class="panel-body">
                                       
                                          <div class="row">
                                             <div class=" grid lg:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 ">
                                               
                                               <form name="createTRPLeadFrom" id="createTRPLeadFrom" method="POST">
                                         <!-- devex start -->
                                                   <br>
                                                    <DxDataGrid
                                                                    :data-source="Exceldata"
                                                                    :columns="columns"
                                                                    width='98.888%'
                                                                    :show-borders="true"
                                                                    :column-min-width="80"
                                                                    :allow-column-resizing="true"
                                                                    column-resizing-mode="widget"
                                                                  >
                                                                  <!-- or"virtual"  | "infinite" |"standard"-->
                                                                  <DxScrolling column-rendering-mode="virtual"/>
                                                                  <DxPaging :page-size="5"/>
                                                                  <DxPager
                                                                      :visible="true"
                                                                      :allowed-page-sizes="pageSizes"
                                                                      :display-mode="displayMode"
                                                                       :show-page-size-selector="showPageSizeSelector"
                                                                      :show-info="showInfo"
                                                                      :show-navigation-buttons="showNavButtons"
                                                                  />
                                                      </DxDataGrid>
                                    <div class="clearfix "></div>
                                    <div class="" style="padding-left:16px ">
                               </div>
                            </form>
                              </div>
                            </div>
                          </div>
                        </div>
                    <!-- datagrid end  -->
    <!-- excel form ends -->
        <div class=" grid grid-cols-4 merg text-left">
          <!-- Main Card-box Starts -->
          <div class="voucher-main-container col-span-4 lg:col-span-3 md:col-span-4 sm:col-span-3">
            <div class="yellow-section" style="background-color: #e0f1fc">
              <h6 class="pt-1 pl-2 pr-2">
                <span class="voucher-heading">VOUCHER</span>
                <span
                  ><button
                    id="inventery_button"
                    class="inventory-submit-btn ml-2 "
                    style="float: right"
                    @click="addinventory($event)"
                    type="submit"
                  >
                    Inventory
                  </button></span
                >
                <span
                  ><button
                    id="ledger_button"
                    class="inventory-submit-btn ml-2"
                    style="float: right"
                    @click="addledger($event)"
                    type="submit"
                  >
                    Ledgers
                  </button></span
                >
                <span
                  ><button
                    id="refresh_voucher_button"
                    class="inventory-submit-btn ml-2  "
                    style="float: right"
                    @click="refresh_ledger_list()"
                    type="submit"
                  >
                    Refresh Ledger
                  </button></span
                >
                <span
                  ><button
                    id="refresh_ledger_button"
                    class="inventory-submit-btn ml-2 "
                    style="float: right"
                    @click="refresh_voucher_list()"
                    type="submit"
                  >
                    Refresh Voucher
                  </button></span
                >
              </h6>
            </div>
            <hr class="voucher-hr">
                            <!-- Rendering data in Voucher -->
            <div style="padding-bottom:1%; ">
                    <!-- Rendering data in Voucher (bk)-->
                      <div class="p-3">  
                            <div class="dx-field">
                                <div class="dx-field-label">DATE:</div>
                                <div class="dx-field-value">
                                  <DxSelectBox 
                                    :data-source="Headers"
                                    :value="voucher.DATE"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="voucher.DATE"
                                   />
                                </div>
                            </div>
                            <div class="mb-2">
                              <div class="dx-field">
                              <div class="dx-field-label">VOUCHERTYPENAME:</div>
                                <div class="dx-field-value grid grid-cols-2 gap-4">
                                  <div>
                                    <DxSelectBox
                                    @value-changed="handleValueChange" 
                                    :data-source="Headers_cust"
                                    :value="voucher.VOUCHERTYPENAME"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="voucher.VOUCHERTYPENAME"
                                    />
                                  </div>
                                  <div>
                                    <DxSelectBox
                                      :data-source="voucher_type_names"
                                      v-model:visible ="selectboxVisiblity"
                                      @value-changed="set_persistedview_name($event)" 
                                      :value="voucher.VOUCHERTYPENAME"
                                      v-model:selectedItem="voucher.VOUCHERTYPENAME"
                                    />
                                  </div>
                                </div>
                              </div>  
                            </div>
                            <div class="dx-field">
                              <div class="dx-field-label">REFERENCE:</div>
                                <div class="dx-field-value">
                                    <DxSelectBox :data-source="Headers"
                                     :value="voucher.REFERENCE"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="voucher.REFERENCE"
                                    />
                                </div>
                            </div>
                            <div class="dx-field">
                              <div class="dx-field-label">VOUCHERNUMBER:</div>
                                <div class="dx-field-value">
                                    <DxSelectBox :data-source="Headers"
                                     :value="voucher.VOUCHERNUMBER"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="voucher.VOUCHERNUMBER"
                                    />
                                </div>
                            </div>
                            <div class="dx-field">
                              <div class="dx-field-label">PARTYLEDGERNAME:</div>
                                <div class="dx-field-value">
                                    <DxSelectBox :data-source="Headers"
                                    :value="voucher.PARTYLEDGERNAME"
                                    :accept-custom-value="true"
                                    v-model:selectedItem="voucher.PARTYLEDGERNAME"
                                    />
                                </div>
                            </div>
                            <div class="dx-field">
                              <div class="dx-field-label">PERSISTEDVIEW:</div>
                                <div class="dx-field-value">
                                    <DxTextBox 
                                      :data-source="Headers"
                                      :value="voucher.PERSISTEDVIEW"
                                      :accept-custom-value="true"
                                      v-model:selectedItem="voucher.PERSISTEDVIEW"
                                      :v-model="voucher.PERSISTEDVIEW=persisted_view"
                                    />
                                  </div>
                            </div>
                           
                            <div class="dx-field">
                              <div class="dx-field-label">BASICBUYERNAME:</div>
                                <div class="dx-field-value">
                                    <DxSelectBox :data-source="Headers"
                                        :value="voucher.BASICBUYERNAME"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="voucher.BASICBUYERNAME"
                                    />
                                </div>
                            </div>
                            <div class="dx-field">
                            <div class="dx-field-label">ISINVOICE:</div>
                              <div class="dx-field-value">
                                    <DxSelectBox
                                     :items="this.is_deemed_positive"
                                        :value="voucher.ISINVOICE"
                                      :accept-custom-value="true"
                                      v-model:selectedItem="voucher.ISINVOICE"
                                    />
                              </div>
                            </div>
                          </div>
                          <div v-for="(value,key) in voucher" track-by="$index">
                              <!-- Inventory starts -->
                                  <div class='key_data voucher-label ml-3' v-if="key=='ALLINVENTORYENTRIES'">
                                    <inventoryentry :is_party_ledger1="is_party_ledger" :is_deemed_positive1="is_deemed_positive" :inventory_arr="value" :inventory_key="key" :Headers="Headers" :Headers_cust="Headers_cust" :Headers_roundOff="Headers_roundOff" :ledger_names="ledger_names" @accountallocation="accountallocation($event)"  @batchallocation="batchallocation($event)" />
                                  </div>
                              <!-- Inventory ends -->   
                              <!-- Ledger starts -->
                                  <div class='key_data voucher-label ml-3' v-if="key=='LEDGERENTRIES'">
                                      <ledgerentry :is_party_ledger1="is_party_ledger" :is_deemed_positive1="is_deemed_positive" :ledger_arr="value" :ledger_key="key" :Headers="Headers" :Headers_cust="Headers_cust" :Headers_roundOff="Headers_roundOff" :ledger_names="ledger_names" @billallocation="billallocation($event)" @bankallocation="bankallocation($event)"/>
                                  </div> 
                              <!-- Ledger ends -->
                          </div>
            </div>
        </div>
        <!-- save section starts -->
            <div class="voucher-main-container col-span-4 lg:col-span-1 md:col-span-4 sm:col-span-1 ">
                        <h6 class="pt-1 pl-2 pr-2 yellow-section">
                            <span class="voucher-heading">SAVE</span>
                        </h6>
                        <hr class="voucher-hr">
                       <div class="save_box pt-1">
                          <div class="editVoucherOptions">
                            <div class="option">
                                <span> Type:</span>
                                    <DxSelectBox
                                        :items="['Voucher', 'Master']"
                                        :value="this.form_data.type"
                                        :accept-custom-value="true"
                                        @value-changed="drop_down_change($event)"
                                      />
                                <div class="option"  v-if="is_visible=='Master'" >
                                  <span> SubType:</span>
                                      <DxSelectBox
                                        :items="['StockGroup','Ledger','Group','StockItem','Godown','Unit']"
                                        :value="subtype"
                                        :accept-custom-value="true"
                                        @value-changed="getMaster($event)"
                                      />
                                  </div>
                                  <div class="option"   v-if="is_visible=='Voucher'">
                                  <span> SubType:</span>
                                      <DxSelectBox
                                        :items="['Sales','Purchase','Recieve','Payment','Credit Note','Debit Note']"
                                        :value="subtype"
                                        :accept-custom-value="true"
                                        @value-changed="getVoucher($event)"
                                      />
                                  </div>
                                <div class="option">
                                    <span>Name:</span>
                                      <DxTextBox
                                        :value="template_name"
                                        :accept-custom-value="true"
                                        @value-changed="getTemplateName($event)"
                                      />
                                </div>
                                <div class="option">
                                    <span>Unique_id:</span>
                                    <DxSelectBox
                                      :data-source="Headers"
                                      :value="this.unique_id"
                                      :accept-custom-value="true"
                                      @value-changed="set_unique_id($event)"
                                    />
                                </div>
                                <div class="grid grid-cols-4 gap-1">
                                      <div class="col-span-1"></div>
                                      <div class="col-span-3">
                                        <span
                                            ><button
                                              id="aggregate field button"
                                              class="inventory-btn ml-2"
                                              style="float: right"
                                              @click="add_aggregate_field()"
                                              type="button"
                                            >
                                                Add Aggregate Field +
                                            </button></span
                                          >
                                      </div>
                                </div>
                               <div class="grid  grid-cols-5 gap-0 "  v-for="(a,index) in aggregate_array">
                                  <div class="option col-span-4" >
                                      <span>aggregate_field:</span>
                                            <DxSelectBox
                                                :data-source="Headers"
                                                :value="aggregate_array[index]"
                                                :accept-custom-value="true"
                                                @value-changed="aggregate_array_value($event,a)"
                                            />
                                  </div>
                                <button class="curve mt-4 ml-2 justify-center " @click="remove_array_field($event)">-</button>
                                 </div>
                                <!-- <div class="">
                                    <div class="grid grid-cols-6 gap-0"  v-for="(a,index) in aggregate_array">
                                      
                                        <DxSelectBox
                                          class="col-span-5"
                                          :data-source="Headers"
                                          :value="aggregate_array[index]"
                                           :accept-custom-value="true"
                                          @value-changed="aggregate_array_value($event,a)"
                                        />
                                       <button class="curve col-span-1"  @click="remove_array_field($event)">-</button>
                                    </div>
                                </div> -->
                                <div style="text-align:center;">
                                            <button type="button" style="font-size: 14px;" class="inventory-submit-btn"
                                                @click="save_json()">Update</button>
                                </div>
                          </div>
                          </div>
                      </div>
                    </div>
                     <DxToast
                        v-model:visible="isVisible"
                        v-model:message="message"
                        v-model:type="toastType"
                    />
        </div>
        </div>
      </div>
        </div>
      <!-- save section ends -->
    </div>
 </app-layout>
</template>
<script>
import navItems from "@include/pages/modules/Components/nav_items";
import { DxToast } from 'devextreme-vue/toast';
import DxNumberBox from 'devextreme-vue/number-box';
import JetNavLink from '@/Jetstream/NavLink.vue';
import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';
import inventoryentry from './inventoryentry';
import ledgerentry from './ledgerentry';
import axios from 'axios';     
import { DxSelectBox } from 'devextreme-vue/select-box';
import {upload,saveJson} from '../TemplateJs/template_db.js';
import { getLedgerNames, getVoucherTypeNames,getVoucherTypeParentNames} from '../TemplateJs/xml_resolver.js';
import {isElectron,getCompanyNames} from '../../UtilsJs/utils.js';
import DxTextBox from 'devextreme-vue/text-box';
import  { DxDataGrid, DxScrolling ,DxColumn,DxPaging,DxPager } from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import DxButton from "devextreme-vue/button";
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import { DxProgressBar } from 'devextreme-vue/progress-bar';
//----------------------//
export default {
  props:{
      id:"",
      type:"",
      subtype:"",
      unique_id_col:"",
      obj_view:"",
      json_template:"",
      template_name:"",
      cmp_name:"",
      pvch_type:"",    //i changed this to pvch_type from vch_type please check whats not working
      aggregate_fields_array:[],
      template_load_count:0
  },
  components: {
      DxToast,
      inventoryentry,
      ledgerentry,
      AppLayout,
      DxSelectBox,
      DxForm,
      JetNavLink,
      DxSimpleItem,
      DxTextBox,
      DxDataGrid,
      DxScrolling,
      DxColumn,
      DxButton,
      DxFileUploader,
      DxPaging,
      DxPager,
      DxProgressBar,
      navItems
  },
   computed:{
     valueString(){
      let mod = JSON.stringify(this.voucher, null, 2);
      return mod;
    },
    valueAggragateString() {
      let mod = JSON.stringify(this.aggregate_array, null, 2);
      return mod;
    },
  },
  data: function () {
    return {
      items: [
          {
            text: 'Admin',
            href: '#'
          },
          {
            text: 'Manage',
            href: '#'
          },
          {
            text: 'Library',
            active: true
          }
        ],
      isVisible: false,
      message: '',
      toastType: 'info',
      displayMode: 'full',
      pageSizes: [5, 10, 'all'],
      showPageSizeSelector: true,
      showInfo: true,
      showNavButtons: true,
      input_filling_check:"",
      uploaded_text_Visible:false,
      uploaded_text:"",
      isDropZoneActive: false,
      imageSource: '',
      textVisible: true,
      progressVisible: false,
      progressValue: 0,
      allowedFileExtensions: ['.jpg', '.jpeg', '.gif', '.png','.xlsx'],
      formData:{},
      mod:'',
      persisted_view:"",
      file: '',
      IsVisible:'',
      selectboxVisiblity:false,
      hlen:0 ,
      VchParentType:'',
      vch_type:'',
      obj_view:'',
      is_tally_open:'',
      mod:'',
      file: '',
      IsVisible:'',      
      obj_view:'',
      ALLINVENTORYENTRIES:[],
      ACCOUNTINGALLOCATIONS:[],
      BATCHALLOCATIONS:[],
      BANKALLOCATIONS:[],
      LEDGERENTRIES:[],
      BILLALLOCATIONS:[],
      Exceldata:[],
      Headers:[],
      //add new array
      Headers_cust:[],
      Headers_roundOff:[],
      //------------//
      template_data:[],
      mergedArr: [],
      template_data:[],
      other_template_info:[],
      company_names:[],
      ledger_names:[],
      arrLedger:[],
      voucher_type_names:[],
      arrVchType:[],
      meta:'',
      voucher: {},
      voucher_type_view:{
            "Payment": "Accounting Voucher View",
            "Receipt": "Accounting Voucher View",
            "Contra": "Accounting Voucher View",
            "Journal": "Accounting Voucher View",
            "Memorandum": "Accounting Voucher View",
            "Reversing Journal": "Accounting Voucher View",
            "Purchase": "Invoice Voucher View",
            "Sales": "Invoice Voucher View",
            "Credit Note": "Invoice Voucher View",
            "Debit Note": "Invoice Voucher View",
            "Delivery Note": "Invoice Voucher View",
            "Receipt Note": "Invoice Voucher View",
            "Sales Order": "Invoice Voucher View",
            "Purchase Order": "Invoice Voucher View",
            "Rejections In":"Invoice Voucher View",
            "Rejections Out":"Invoice Voucher View",
            "Physical Stock": "Invoice Voucher View",
            "Stock Journal": "Consumption Voucher View",
            "Material In": "Multi Consumption Voucher View",
            "Material Out": "Multi Consumption Voucher View",
            "Attendance": "Accounting Voucher View",
            "Job Work In Order": "Invoice Voucher View",
            "Job Work Out Order": "Invoice Voucher View"
        },
        is_deemed_positive:["Yes", "No"],
        is_deemed_positive1:[{"value":"Yes","label":"Dr"},{"value":"No","label":"Cr"}],
        is_voucher:{ "Yes": "Yes", "No": "No" },
        is_voucher1:[{"value":"Yes","label":"Yes"},{"value":"No","label":"No"}],
        is_party_ledger:[{ "Yes": "Yes", "No": "No" }],
        is_party_ledger1:[{"value":"Yes","label":"Yes"},{"value":"No","label":"No"}],
        aggregate_array:[""],
        custom_value:["--CUSTOM--"],
        type_arr:['-NA-','voucher','master'],
        sub_type_voucher_arr:['-NA-','Sales','Purchase','Receipt','Payment','Credit Note','Debit Note'],
        sub_type_master_arr:['-NA-','Ledgers','Groups','Stock-Groups','Stock-Items','Units','Godowns'],
         // DXSimpleItem related array add new code //
        is_visible:"", 
        typeArr:[{"value":"Voucher","label":"Voucher"},{"value":"Master","label":"Master"}],
            voucherTypeArr:[{"value":"Sales","label":"Sales"},
                {"value":"Purchase","label":"Purchase"},
                {"value":"Recieve","label":"Recieve"},
                {"value":"Payment","label":"Payment"},
                {"value":"CreditNote","label":"CreditNote"},
                {"value":"DebitNote","label":"DebitNote"}],
            masterTypeArr:[
                {"value":"StockGroup","label":"StockGroup"},
                {"value":"Ledger","label":"Ledger"},
                {"value":"Group","label":"Group"},
                {"value":"StockItem","label":"StockItem"},
                {"value":"Godown","label":"Godown"},
                {"value":"Unit","label":"Unit"}
            ],
            form_data:{"type":"","Subtype":"","Name":"","vch_type":"","obj_view":"","company_name":""},
            typeOptions:{
                items:['Voucher','Master']
            },
            VoucherSubTypeOptions:{
                items:['Sales','Purchase','Recieve','Payment','Credit Note','Debit Note']     
            },
            MasterSubTypeOptions:{ 
                items:['StockGroup','Ledger','Group','StockItem','Godown','Unit']  
            },
            aggregate_array_values:[],
            unique_id:"",
            company_name:"",
            breadcrumbs:[{'route':'templates.index','name':'Templates'},{'route':'templates.show','name':'Show Template'}]
    };
  },  
  methods:{
    fetchCompanyName(e){
        this.form_data.company_name=e.value;
    },
    getMaster(e){
        this.form_data.Subtype=e.value;
    },
    getVoucher(e){
        this.form_data.Subtype=e.value;
    },
    getTemplateName(e){
        this.form_data.Name=e.value;
    },
    //// Select combobox  new code added------///
    handleValueChange(e){
      if(e.value=="--CUSTOM--"){  
      this.selectboxVisiblity =true;
      }
    },
     //save Save DXSimpleItem
    drop_down_change(e){
      this.form_data.type=e.value;
        if(e.value == "Voucher"){
            this.is_visible = "Voucher";
        } 
        else if(e.value == "Master"){
            this.is_visible = "Master";
        }
    },
     //-----------------------//    
    addinventory(obj){
         if (obj.target.attributes.id.value == 'inventery_button') {
                var txtVal = 'ALLINVENTORYENTRIES';
                if (!(txtVal in this.voucher)) {
                    this.ALLINVENTORYENTRIES = [{
                        "STOCKITEMNAME": "",
                        "ISDEEMEDPOSITIVE": "",
                        "ACTUALQTY": "",
                        "BILLEDQTY": "",
                        "RATE": "",
                        "AMOUNT": "",
                        "ACCOUNTINGALLOCATIONS": [{
                            "LEDGERNAME": "",
                            "AMOUNT": ""
                        }]
                    }];
                    this.voucher.ALLINVENTORYENTRIES = this.ALLINVENTORYENTRIES;
                }
                else if ((txtVal in this.voucher)) {
                    this.voucher.ALLINVENTORYENTRIES.push({
                        "STOCKITEMNAME": "",
                        "ISDEEMEDPOSITIVE": "",
                        "ACTUALQTY": "",
                        "BILLEDQTY": "",
                        "RATE": "",
                        "AMOUNT": "",
                         "ACCOUNTINGALLOCATIONS": [{
                            "LEDGERNAME": "",
                            "AMOUNT": ""
                        }]
                    });
                }
            }
    },
    addledger(obj){
         if (obj.target.attributes.id.value == 'ledger_button') {
                var txtVal = 'LEDGERENTRIES';
                if (!(txtVal in this.voucher)) {
                    this.LEDGERENTRIES = [{
                        "LEDGERNAME": "",
                        "AMOUNT": "", "ISDEEMEDPOSITIVE": "","ISPARTYLEDGER":""
                    }];
                    this.voucher.LEDGERENTRIES = this.LEDGERENTRIES;
                }
                else if ((txtVal in this.voucher)) {
                    this.voucher.LEDGERENTRIES.push({
                        "LEDGERNAME": "",
                        "AMOUNT": "", "ISDEEMEDPOSITIVE": "", "ISPARTYLEDGER": ""
                    });
                }
            }
    },
    accountallocation(obj){
       var txtVal = 'ACCOUNTINGALLOCATIONS';
            if (!(txtVal in obj)) {
                this.ACCOUNTINGALLOCATIONS = [{
                    "LEDGERNAME": "GST Sales Local",
                    "AMOUNT": "1000", "ISDEEMEDPOSITIVE": ""
                }];
                obj.ACCOUNTINGALLOCATIONS = this.ACCOUNTINGALLOCATIONS;
            }
            else if ((txtVal in obj)) {
                this.ACCOUNTINGALLOCATIONS = {
                    "LEDGERNAME": "GST Sales Local",
                    "AMOUNT": "1000", "ISDEEMEDPOSITIVE": ""
                }
                obj.ACCOUNTINGALLOCATIONS.push(this.ACCOUNTINGALLOCATIONS);
            }
    },
    batchallocation(obj){
            var txtVal = 'BATCHALLOCATIONS';
            if (!(txtVal in obj)) {
                this.BATCHALLOCATIONS = [{
                    "BATCHNAME": "",
                    "QTY": "",
                    "GODOWNNAME": "",
                    "RATE": "",
                    "AMOUNT": "", "ISDEEMEDPOSITIVE": ""
                }];
                obj.BATCHALLOCATIONS = this.BATCHALLOCATIONS;
            }
            else if ((txtVal in obj)) {
                this.BATCHALLOCATIONS = {
                    "BATCHNAME": "",
                    "QTY": "",
                    "GODOWNNAME": "",
                    "RATE": "",
                    "AMOUNT": "", "ISDEEMEDPOSITIVE": ""
                }
                obj.BATCHALLOCATIONS.push(this.BATCHALLOCATIONS);
            }
    },
    bankallocation(obj){
         var txtVal = 'BANKALLOCATIONS';
            if (!(txtVal in obj)) {
                this.BANKALLOCATIONS = [{ "ISDEEMEDPOSITIVE": "Yes", }];
                obj.BANKALLOCATIONS = this.BANKALLOCATIONS;
            }
            else if ((txtVal in obj)) {
                this.BANKALLOCATIONS = { 'EXIST': 'YES' }
                obj.BANKALLOCATIONS.push(this.BANKALLOCATIONS);
            }
    },
    billallocation(obj){
        var txtVal = 'BILLALLOCATIONS';
            if (!(txtVal in obj)) {
                this.BILLALLOCATIONS = [{ "BILLNAME": "", "BILLAMOUNT": "", }];
                obj.BILLALLOCATIONS = this.BILLALLOCATIONS;
            }
            else if ((txtVal in obj)) {
                this.BILLALLOCATIONS = { "BILLNAME": "", "BILLAMOUNT": "", }
                obj.BILLALLOCATIONS.push(this.BILLALLOCATIONS);
            }
    },
    handleFileUpload(e){
        this.file = e.value;
    },
    processUpload :  function(e){
        const _this =this;
        const file = this.file[0];
        upload(_this,file);
    },
    save_json : function(){
        let json_template = JSON.stringify(this.voucher, null, 2);
        this.form_data.obj_view = this.obj_view;
        this.template_data = [];
        let url = '/templates/update_template';
        let params = {'form_data':this.form_data,template:json_template,"aggeregate_array":JSON.stringify(this.aggregate_array_values),'id':this.id,"unique_id":this.unique_id};
       saveJson(url,params);
    },
    // code updated//
    set_persistedview_name :  function(e){
        var _this=this;
        _this.form_data.vch_type=e.value;
        _this.vch_type=e.value;
        _this.form_data.obj_view=e.value;
        getVoucherTypeParentNames(_this,e.value,this.metas);
    },
    refresh_voucher_list : function(){
        var _this=this;
        getVoucherTypeNames(_this);
    },
    refresh_ledger_list : function(){
        var _this=this;
        getLedgerNames(_this);
    },
    getCookie(name) {
        const value = `; ${document.cookie}`;
        return value.split(";")[1].split("=")[1];
    },
    add_aggregate_field(){
        this.aggregate_array.push("");
    },
    aggregate_array_value(e,changed_value){

        if(this.aggregate_array.indexOf(e.value) == -1){
            if(this.aggregate_array_values.length < this.aggregate_array.length && changed_value == ''){
                this.aggregate_array_values.push(e.value);
                var index = this.aggregate_array_values.indexOf(e.value);
                this.aggregate_array.splice(this.aggregate_array.indexOf(index),1,e.value);
            }
            else{
                this.aggregate_array.splice(this.aggregate_array.indexOf(changed_value), 1, e.value);
                this.aggregate_array_values = this.aggregate_array;
            }
        }
    },
    remove_array_field(e){
        var remove_id =e.target.parentElement;
        var remove_value = remove_id.children[0].children[1].children[0].children[0].value;
        this.aggregate_array.splice(this.aggregate_array.indexOf(remove_value), 1);
        this.aggregate_array_values = this.aggregate_array;
    },
    set_unique_id(e){
          this.unique_id=e.value; 
    },
    onDropZoneEnter(e){
          if (e.dropZoneElement.id === 'dropzone-external') {
              this.isDropZoneActive = true;
          }
    },
    onDropZoneLeave(e){
        if (e.dropZoneElement.id === 'dropzone-external') {
            this.isDropZoneActive = false;
        }
    },
    viewExcelData(e){
        var _this = this;
        // getExcelSheetDataView(_this,this.file[0]);
        this.isDataViewModalVisible = true;
    },
    onUploaded(e){
        const { file } = e;
        const fileReader = new FileReader();
        fileReader.onload = () => {
            this.isDropZoneActive = false;
            this.imageSource = fileReader.result;
        };
        fileReader.readAsDataURL(file);
        this.textVisible =false;
        this.progressVisible = false;
        this.uploaded_text_Visible=true;
        this.uploaded_text=e.file.name;
        this.progressValue = 0;
        var _this = this;
        // getExcelSheetDataView(_this,this.file[0]);
    },
    onProgress(e){
        this.progressValue = (e.bytesLoaded / e.bytesTotal) * 100;
    },
    onUploadStarted(){
        this.imageSource = '';
        this.progressVisible = true;
    },
  },
  mounted(){
      if(this.template_load_count == 1){
          location.reload();
      }
      this.is_visible = this.type;
      this.voucher = this.json_template;
      this.form_data.type=this.type;
      this.form_data.Subtype=this.subtype;
      this.form_data.Name=this.template_name;
      this.unique_id = this.unique_id_col;
      this.aggregate_array = this.aggregate_fields_array;
      this.aggregate_array_values = JSON.parse(JSON.stringify(this.aggregate_array));
      this.form_data.company_name = this.cmp_name;
      $('#type').on('change', function () {
          if($(this).val()=="Voucher"){
              $('#Voucher').css('display','block');
              $('#Master').css('display','none');
          }
          else{
              $('#Voucher').css('display','none');
              $('#Master').css('display','block');
          };  
      })
      $('#VOUCHERTYPENAME').on('change', function () {
          if ($(this).val() == "Custom") {
              $(this).attr('class', function () {
                  return "voucher-select   ml-32 col-span-1 xl:w-44 lg:w-36 sm:w-36 pt-0 mb-1 leading-4";
              })  
              $('#Custom_VOUCHERTYPENAME').css('display', 'inline');
              $('.voucher_refreshbutton').css('display', 'inline');
          }
      }),
      $(document).on('change', '#LEDGERNAME', function () {
          if ($(this).val() == "Custom") {
              $(this).parent().find('.Custom_ledger_show').css('display', 'inline')
              $(this).parent().find('.refreshbutton').css('display', "inline")
              $(this).attr('class', function (){
                  return " sm:mr-1 mr-8 ml-32 voucher-select col-span-1 xl:w-36 lg:w-32 sm:w-36 pt-0  leading-4";
              })
          }
      }),
      $(document).on('change', '#accounting_LEDGERNAME', function () {
          if ($(this).val() == "Custom") {
              $(this).parent().find('.accounting_Custom_ledger_show').css('display', 'inline')
              $(this).parent().find('.refreshbutton').css('display', "inline")
              $(this).attr('class', function (){
                  return " sm:mr-1 mr-8 ml-24 voucher-select col-span-1 xl:w-36 lg:w-32 sm:w-36 pt-0  leading-4";
              })
          }
      })
  },
  created:function(){
    var _this=this;
    if(isElectron()){
          this.metas = "electron";
          window.api.send('checkTallyOpening'); 
          window.api.receive("checkTallyOpening-reply", (tally_response) => {
              if(tally_response == "tally is open"){
                getCompanyNames(_this,this.metas);
                getLedgerNames(_this,this.metas);  
                getVoucherTypeNames(_this,this.metas);
              }
              else{
                this.isVisible=true;
                this.message='Tally Is Not Open';
                this.toastType='info';
              }
          });
    }
    else{
          axios.post('/checkTallyIsOpen')
          .then((result) => {
              if(result.data=="not_open"){
                  alert('tally is not open');
              }
              else{
                  getCompanyNames(_this,this.meta);
                  getLedgerNames(_this,this.meta);  
                  getVoucherTypeNames(_this,this.meta);
              }
          })
    }
  }
};
</script>
<style >
.crumb1{
  padding:10px;
}
.crumb1 li
{
  display: inline-block;
  padding: 1px;
  background: transparent;
  transform: skew(-20deg);
  cursor: pointer;
  opacity: 0.8;
}

.crumb1 li:hover
{
  opacity: 1;
}
li {
    border: none!important;
}
.box {
  border: 2px solid rgb(136, 136, 243);
  width: 550px;
}
.container{
    max-width: 1340px;
}
h6 {
  margin: 0px 0px 0px !important;
  padding: 0px 0px 7px !important;
}
.key_data {
  padding-left: 1%;
  padding-right: 1%;
}
.inventory_header {
  margin-block-start: 0px;
  background-color: rgb(111, 203, 219);
  padding: 10px;
  border-radius: 10px 10px 10px 10px;
}
.ledger_header {
  margin-block-start: 0px;
  background-color: rgb(111, 203, 219);
  padding: 10px;
  border-radius: 10px 10px 10px 10px;
}
#amt {
  visibility: hidden;
}
#inventory {
  /* border: 2px solid lightgrey !important;
            border-top: none !important; */
}
#ledgers {
  /* border: 2px solid lightgrey !important;
            border-top: none !important; */
}
.btn {
  padding: 0 2% 0 2%;
}
.upload_box {
  width: 400px;
  box-sizing: border-box;
}
.upbtn {
  margin-top: 7px;
}
/* rejected css */
/* rejected css end */
.voucher-heading {
  font-size: 12px;
}
.inventory-submit-btn {
  font-size: 12px;
  border: 1px solid #2A66B1;
  color: #FFFFFF;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #2A66B1;
}
.testimonial-group {
  padding: 0px !important;
}
.voucher-main-container {
  border: 1px solid #CECECE;
}
.voucher-hr {
  margin: 0px !important;
}
.file_upload[type="file"] {
  color: #2A66B1;
  font-size: 12px;
  border: 1px solid #2A66B1;
}
.voucher-select {
  border: 1px solid #CECECE;
}
.voucher-label {
  font-size: 12px;
  font-weight: bold;
}
.cmpName{
  font-size: 14px;
  font-weight: bold;
}
.file_upload[type="file"]::file-selector-button {
  border: 0px solid #2A66B1;
  padding: 0.4em 0.1em;
  color: #FFFFFF;
  border-radius: 0px !important;
  background-color: #2A66B1;
}
.voucher-select::after {
  color: #CECECE;
}
.display-block {
  display: inline;
}
.yellow-section {
}
.create-trp-lead-from {
  margin-top: -22px !important;
}
.refreshbutton {
  font-size: 12px;
  width: 20px !important;
  height: 20px !important;
  border: 0px solid #2A66B1;
  background-color: #2A66B1;
  border-radius: 100px;
  color: #FFFFFF;
  font-weight: 500;
}
.voucher_refreshbutton {
}
 .name{
     margin-left: 8rem;
    margin-right:5rem ;
  }
  @media (max-width: 640px) {
 .font{
     font-size: 11px;
 }
 .merg{
    margin-left: 15px;
    margin-right: 15px;
}
.inventory-submit-btn {
  font-size: 10px;
  border: 1px solid #2A66B1;
  color: #FFFFFF;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 7px;
  padding-right: 7px;
  background-color: #2A66B1;
  margin-left: 1px;
  margin-right: 1px;
}
 }
.sub{
   margin-top: 30px;
   margin-left: -203px;
 }
.master{
  margin-top: 30px;
  margin-left: -210px;
 }
.main-content {
  background-color: #F3F4F6;
  /* width: calc(100% - 250px); */
  /* height: 100vh; */
  margin-left: 212px;
  padding-bottom: 10px;
}
.container{
  text-align: center;
}
        /* upload image devex */
#dropzone-external {
  width: 320px;
  height: 70px;
  background-color: rgba(183, 183, 183, 0.1);
  border-width: 2px;
  border-style: dashed;
  padding: 10px;
}
#dropzone-external > * {
  pointer-events: none;
}
#dropzone-external.dropzone-active {
  border-style: solid;
}
.widget-container > span {
  font-size: 14px;
  /* font-weight: bold; */
  margin-bottom: 5px;
  margin-top: 7px;
  margin-right: 240px;
}
#dropzone-image {
  max-width: 70%;
  max-height: 70%;
}
#dropzone-text > span {
  font-weight: 100;
  opacity: 0.5;
}
#upload-progress {
  display: flex;
  margin-top: 10px;
}
/* *Extra small devices (phones, 600px and down) */ 
@media only screen and (max-width: 600px){
#dropzone-external {
  width: 180px;
}
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
#dropzone-external {
  width: 180px;
}
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
#dropzone-external {
  width: 180px;
}
#dropzone-text > span {
  font-weight: 2px;
  font-size: 15px;
  opacity: 0.5;
}
#sub{
  margin-left: 50px;
}
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
#dropzone-external {
  width: 200px;
}
#sub{
  margin-left: 20px;
}
}
@media only screen and (min-width: 1024px) {
#dropzone-external {
  width: 260px;
}
}
@media only screen and (min-width: 1284px) {
#dropzone-external {
  width: 280px;
}
}
@media only screen and (min-width: 1536px) {
#dropzone-external {
  width: 320px;
}
}
.editVoucherOptions {
  padding: 20px;
}
.inventory-btn {
  font-size: 12px;
  border: 1px solid #2A66B1;
  color: #FFFFFF;
  margin-top: 15px;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #2A66B1;
}
.curve {
  background: none;
  color: rgb(185, 184, 184);
  border: 1px solid rgb(185, 184, 184);
  border-radius: 5px;
  font-size: 16px;
  padding: 4px 12px;
  text-decoration: none; }
  .two {
  /* display: -webkit-box;
  display: -ms-flexbox; */
  display: flex;
  -webkit-box-pack: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
  margin-top: 24px;
   }
</style>